






















import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import {
  NOW_START_MONTH,
  NOW_END_MONTH,
  toCommaFormat,
} from '@/utils';
import CommonProductTypeSelect from '@/components/Product/CommonProductTypeSelect.vue';

import incomeProductTypeTable from '@/table/report/management/incomeProductType';

const TableIncomeProductType = defineComponent({
  components: {
    CommonProductTypeSelect,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    query: {
      default: undefined,
    },
    result: {
      type: Function,
      default: undefined,
    },
  },
  setup(props) {
    const filter = reactive({
      productType: undefined,
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
    });
    const { result, loading } = useQuery(
      props.query as any,
      computed(() => ({
        timeframe: filter.monthRange,
        productTypeId: filter.productType ? (filter.productType as any).id : undefined,
      })),
      () => ({
        fetchPolicy: 'network-only',
        enabled: props.query !== undefined && props.result !== undefined,
      }),
    );
    const getDataArray = computed(() => {
      if (loading.value === false && result.value && props.result !== undefined) {
        return props.result(result.value);
      }
      return [];
    });

    return {
      filter,
      getDataArray,
      toCommaFormat,

      incomeProductTypeTable,
    };
  },
});

export default TableIncomeProductType;
